/*
 * ParentPlanner Messages
 *
 * This contains all the text for the ParentPlanner component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.ParentPlanner.header',
    defaultMessage: 'Select a Time for \'{title}\'',
  },
  options: {
    id: 'app.components.ParentPlanner.options',
    defaultMessage: 'options',
  },
  close: {
    id: 'app.common.close',
    defaultMessage: 'Close',
  },
  changeHelp: {
    id: 'app.components.ParentPlanner.changeHelp',
    defaultMessage: 'To change a time, select a new time slot, it will replace the old one.',
  },
  notSelectedYet: {
    id: 'app.components.ParentPlanner.notSelectedYet',
    defaultMessage: 'Not selected yet',
  },
  select: {
    id: 'app.components.ParentPlanner.select',
    defaultMessage: 'Select',
  },
  available: {
    id: 'app.components.ParentPlanner.available',
    defaultMessage: 'Available',
  },
  occupied: {
    id: 'app.components.ParentPlanner.occupied',
    defaultMessage: 'Occupied',
  },
  backToOverview: {
    id: 'app.components.ParentPlanner.backToOverview',
    defaultMessage: 'Back to Overview',
  },
  yourTime: {
    id: 'app.components.ParentPlanner.yourTime',
    defaultMessage: 'Your Time',
  },
  removeSlot: {
    id: 'app.components.ParentPlanner.removeSlot',
    defaultMessage: 'Remove reservation for this time slot?',
  },
  assigned: {
    id: 'app.components.ParentPlanner.assigned',
    defaultMessage: 'Assigned',
  },
  notStarted: {
    id: 'app.components.ParentPlanner.notStarted',
    defaultMessage: 'Not started yet',
  },
  alreadyClosed: {
    id: 'app.components.ParentPlanner.alreadyClosed',
    defaultMessage: 'Closed already',
  },
  alreadyPast: {
    id: 'app.components.ParentPlanner.alreadyPast',
    defaultMessage: 'Time slot in the past',
  },
  noSlots: {
    id: 'app.components.Period.noSlots',
    defaultMessage: 'There are no time slots yet',
  },
  meetingLocationType: {
    id: 'app.components.Planner.meetingLocationType',
    defaultMessage: 'Location',
  },
  selectLocationType: {
    id: 'app.components.ParentPlanner.selectLocationType',
    defaultMessage: 'Select a location for the meeting',
  },
  onPremises: {
    id: 'app.components.Planner.onPremises',
    defaultMessage: 'On Premises',
  },
  videoMeeting: {
    id: 'app.components.Planner.videoMeeting',
    defaultMessage: 'Video Conference',
  },
  assignedByTeacher: {
    id: 'app.components.ParentList.assigned',
    defaultMessage: 'Assigned by teacher',
  },
  hasVideoLink: {
    id: 'app.components.ParentList.videoLinkNoChange',
    defaultMessage: 'You cannot change the time anymore, a video conference link has already been added',
  },
  replaceMeeting: {
    id: 'app.components.MeetingsBlock.replaceMeeting',
    defaultMessage: 'Replace meeting of {timeslot}?',
  },
});
